module.exports = __webpack_public_path__ + "static/media/green-lock.4deb9e2a.svg";